(function() {
  'use strict';

  angular.module('component.announcements')
    .component('announcement', {
      templateUrl: 'app/components/announcements/form.html',
      controller: 'AnnouncementController',
      controllerAs: 'announcementCtrl',
      bindings: {
        announcementId: '<'
      }
    });
})();
